import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { ROLES } from "../models/enumeration-list.model";

@Injectable({
    providedIn: 'root'
  })
  export class BasedRoleOPathService {
    constructor(private dataService: DataService) {}
  
  
    private getProjectId(): string {
      return localStorage.getItem('projectId');
    }
    private getProfileId(): string {
        return sessionStorage.getItem('profileId');
      }
      public generateOPath(baseOPath: string, subPathMap: { [role: string]: string }): string {
        let oPathExpression = baseOPath;
        const profileId = this.getProfileId();
        
        let role = this.dataService.userRoles[0] 
          if (subPathMap[role]) {
            oPathExpression = subPathMap[role].replace('{profileId}', profileId);
          }
        
        
        return oPathExpression;
       }

       public checkSubprojectOPath(): string {
        const baseOPath = `ParentId='${this.getProjectId()}'`;
        const roleToOPathMap = {
          [ROLES.SubprojectDeputy]: `ParentId='${this.getProjectId()}' And IdRefResponsibleSupport='{profileId}'`,
          [ROLES.SubprojectResponsible]: `ParentId='${this.getProjectId()}' And IdRefresponsible='{profileId}'`,
          [ROLES.MeasureManager]: `ParentId='${this.getProjectId()}' And measures.IdRefPersonResponsible='{profileId}'`,
          [ROLES.MeasureParticipant]: `ParentId='${this.getProjectId()}' And measures.MeasureResources.IdRefPerson='{profileId}'`
        };
    
        return this.generateOPath(baseOPath, roleToOPathMap);
      }
      
      public checkMeasureOPath(): string {
        const baseOPath = `!.ParentId='${this.getProjectId()}'`;
        const roleToOPathMap = {
          [ROLES.MeasureParticipant]: `!.ParentId='${this.getProjectId()}' And MeasureResources.IdRefPerson='{profileId}'`,
          [ROLES.MeasureManager]: `!.ParentId='${this.getProjectId()}' And IdRefPersonResponsible='{profileId}'`,
          [ROLES.SubprojectDeputy]:`!.ParentId='${this.getProjectId()}' And Type(xmtSubProject)[Id=^.ParentId].IdRefResponsibleSupport='{profileId}'`,
          [ROLES.SubprojectResponsible]:`!.ParentId='${this.getProjectId()}' And Type(xmtSubProject)[Id=^.ParentId].IdRefresponsible='{profileId}'`
        };
    
        return this.generateOPath(baseOPath, roleToOPathMap);
      }


  public checkGantOPathForSubProject(): string {
    const baseOPath = `ParentId='${this.getProjectId()}'`;
    const roleToOPathMap = {
      [ROLES.MeasureParticipant]: `ParentId='${this.getProjectId()}' And measures.MeasureResources.IdRefPerson='{profileId}'`,
      [ROLES.MeasureManager]: `ParentId='${this.getProjectId()}' And measures.IdRefPersonResponsible='{profileId}'`,
      [ROLES.SubprojectDeputy]: `ParentId='${this.getProjectId()}' And IdRefResponsibleSupport='{profileId}'`,
      [ROLES.SubprojectResponsible]: `ParentId='${this.getProjectId()}' And IdRefresponsible='{profileId}'`
    };

    return this.generateOPath(baseOPath, roleToOPathMap);
  }
  public CheckGantOpathForMeasures():string{
    const baseOpath='measures'
    const roleToOPathMap={
        [ROLES.MeasureParticipant]: `measures[MeasureTasks.collaborators.MeasureResource.IdRefPerson='{profileId}']`,
        [ROLES.MeasureManager]:  `measures[IdRefPersonResponsible='{profileId}']`
    }
    return  this.generateOPath(baseOpath,roleToOPathMap)
  }

  public checkMeasureTaskOPath(): string {
    const baseOPath = `!.!.ParentId='${this.getProjectId()}'`;
    const roleToOPathMap = {
      [ROLES.MeasureParticipant]: `!.!.ParentId='${this.getProjectId()}' And Type(xmtMeasure)[Id=^.ParentId].MeasureResources.IdRefPerson='{profileId}'`,
      [ROLES.MeasureManager]: `!.!.ParentId='${this.getProjectId()}' And Type(xmtMeasure)[Id=^.ParentId].IdRefPersonResponsible='{profileId}'`,
      [ROLES.SubprojectDeputy]: `!.!.ParentId='${this.getProjectId()}' And Type(xmtMeasure)[Id=^.ParentId].SubProject.IdRefResponsibleSupport='{profileId}'`,
      [ROLES.SubprojectResponsible]: `!.!.ParentId='${this.getProjectId()}' And Type(xmtMeasure)[Id=^.ParentId].SubProject.IdRefresponsible='{profileId}'`
    };

    return this.generateOPath(baseOPath, roleToOPathMap);
  }


  
}